import Constants from 'constants';

const _defaultState = {
    fetchingBookingDetails: false,
    bookingDetails: {},
    hcnUpdateResponse: false,
    updatingHcn: false
},

    hcnUpdate = (state = _defaultState, action) => {
        try {
            const { type, payload } = action;
            switch (type) {
                case Constants.actions.HCN_UPDATE.FETCHING_BOOKING_DETAILS:
                    return {
                        ...state,
                        fetchingBookingDetails: true,
                        hcnUpdateResponse: false
                    }
                case Constants.actions.HCN_UPDATE.OPEN_BOOKING_DETAILS:
                    const { errors = [] } = payload,
                        [firstErr = {}] = errors,
                        { details = "", errCode = "", message = "" } = firstErr;
                    return {
                        ...state,
                        bookingDetails: payload,
                        fetchingBookingDetails: false,
                        ...(errCode == "6115" && { hcnUpdateResponse: true })
                    }
                case Constants.actions.HCN_UPDATE.UPDATING_HCN:
                    return {
                        ...state,
                        updatingHcn: true,
                        hcnUpdateResponse: false
                    }
                case Constants.actions.HCN_UPDATE.HCN_UPDATED:
                    return {
                        ...state,
                        updatingHcn: false,
                        hcnUpdateResponse: true
                    }
                default:
                    return state;
            }
        } catch (error) {
            return _defaultState;
        }
    };

export default hcnUpdate;
